
import React from 'react';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import WhyUsSection from '../components/WhyUsSection';
import LatestUpdatesSection from '../components/LatestUpdatesSection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <WhyUsSection />
      <LatestUpdatesSection />
    </div>
  );
};

export default Home;
